import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-carpark-list-footer',
  templateUrl: './carpark-list-footer.component.html',
  styleUrls: ['./carpark-list-footer.component.scss']
})
export class CarparkListFooterComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
